import { render } from "./createPublicPersonStepAnex.vue?vue&type=template&id=06d9efdc&scoped=true"
import script from "./createPublicPersonStepAnex.vue?vue&type=script&lang=js"
export * from "./createPublicPersonStepAnex.vue?vue&type=script&lang=js"

import "./createPublicPersonStepAnex.vue?vue&type=style&index=0&id=06d9efdc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d9efdc"]])

export default __exports__